import { type LookupDefinition } from 'api/hooks/useGetParameterOptions/types'

import {
  type ComponentInstanceId,
  type TransformationJob
} from 'job-lib/types/Job'

import {
  getComponentDependencyData,
  type ValidationQueryCache
} from 'modules/core/ComponentValidation'

export interface GetTransformSQLDependenciesOptions {
  validationQueryCache: ValidationQueryCache
  lookupDependencies: string[]
  componentId?: ComponentInstanceId | null
  job: TransformationJob
}

export type TransformSQLDependencies = Pick<LookupDefinition, 'transform.sql'>

export const getTransformSQLDependencies = ({
  validationQueryCache,
  lookupDependencies,
  componentId,
  job
}: GetTransformSQLDependenciesOptions):
  | TransformSQLDependencies
  | undefined => {
  if (componentId == null) return
  if (!lookupDependencies.includes('transform.sql')) return undefined
  if (!job) return undefined

  const bag = getComponentDependencyData(job, componentId, validationQueryCache)

  if (!Object.keys(bag?.cache).length) {
    return { 'transform.sql': {} }
  }

  return { 'transform.sql': { ...bag.cache } }
}
